import {__NAME__, AppConfig} from './types'

export const config: AppConfig = window[__NAME__]

const env = config.env
export const isDevEnv = env === 'development'

export const isMarketIntegration = () => config.sourceService === 'market'
